// import Swiper from 'swiper';
// import 'swiper/css';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import { Navigation, Pagination } from 'swiper/modules';

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

    console.log("DOM loaded");
   
    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e){
   
     //custom GSAP code goes here
     // This tween will rotate an element with a class of .my-element
      gsap.to('.my-element', {
       rotation: 360,
       duration: 2,
       ease: 'bounce.out'
      })
   
      console.log("window loaded");
     }, false);
   
   });

   document.addEventListener('DOMContentLoaded', function(){
    const swiper = new Swiper('.swiper-container', {
      mousewheel: {
        releaseOnEdges: true,
        forceToAxis:true
      },
      slidesPerView : 4,
      spaceBetween : 30,
      grabCursor : true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      effect:'slide',
      speed:1000,
      breakpoints: {
        320: {
          slidesPerView: 1.1,
        },
        640: {
          slidesPerView: 2.5,
        },
        1000: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4
        }
      },
    });
    console.log('Swiper initialized!');
   });

   document.addEventListener('DOMContentLoaded', function () {
    const menuBtn = document.querySelector('.menu-btn-burger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const menuClose = document.querySelector('.mob-menu-close');

    menuBtn.addEventListener('click', () => {
        mobileMenu.classList.add('active'); 
        menuBtn.style.display = 'none'; 
        menuClose.style.display = 'block'; 
    });

    menuClose.addEventListener('click', () => {
        mobileMenu.classList.remove('active');
        menuClose.style.display = 'none'; 
        menuBtn.style.display = 'block'; 
    });
});


   